export const CustomerStories = () => {
    return (
        <section id="customer-stories">
            <h2>For teams of all sizes</h2>
            <hr />
        </section>
    );
};
